import React from "react";
import "./buttons.scss";
import { MdMyLocation } from "react-icons/md";
import { IconContext } from "react-icons";
import { Tooltip } from "wm_global";

export const LinkAsActionButtonA = ({
  url,
  children,
  addtlCssClasses = null,
}) => {
  const classes = () => {
    let _classes = "btn pwm-action-button";

    if (addtlCssClasses) {
      _classes += " ";
      _classes += addtlCssClasses;
    }
    return _classes;
  };

  return (
    <a href={url} className={classes()}>
      {children}
    </a>
  );
};

export const GrahamLinkAsActionButton = ({ url, children }) => {
  return (
    <a href={url} className={"btn graham-action-button"}>
      {children}
    </a>
  );
};

export const ActionButtonA2 = ({
  onClick,
  children,
  type = "button",
  disabled = false,
  cssClasses = "btn pwm-action-button",
  id = null,
  testId = null,
  inLineStyle = {},
  addtlCssClasses = "",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={cssClasses + " " + addtlCssClasses}
      disabled={disabled}
      id={id}
      data-testid={testId}
      style={inLineStyle}
    >
      {children}
    </button>
  );
};

export const LocateMeBullsEyeButton = ({ setUsersCoords }) => (
  <Tooltip title="Use my location">
    <button
      onClick={setUsersCoords}
      className="locate-me-be-button"
      type="button"
    >
      <IconContext.Provider value={{ className: "locate-me-be-button__image" }}>
        <MdMyLocation />
      </IconContext.Provider>
      <span className="locate-me-be-button__text">Locate Me</span>
    </button>
  </Tooltip>
);
